import React from "react";
import "./bodyCardEventSlider.sass";

export default function TeamMiddleSlider({ urlEvento }) {

    return (
        <div className="container-middle-body">
            {String(urlEvento)
                ?
                <a className="a-middle-body" href={urlEvento} target="_top">
                    <span className="middle-point">●</span>
                </a>
                :
                <p className="a-middle-body">
                    <span className="middle-point">●</span>
                </p>
            }
        </div>
    )
}